import { render, staticRenderFns } from "./PeriodoResumo.vue?vue&type=template&id=6af362a0"
import script from "./PeriodoResumo.vue?vue&type=script&lang=js"
export * from "./PeriodoResumo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports